export enum MarginType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}

export interface IMarginValue {
  value?: number;
  type?: MarginType;
}

export class MarginValue implements IMarginValue {
  constructor(
    public value?: number,
    public type?: MarginType
  ) {}
}
